/* eslint-disable */
// AUTO-GENERATED - DO NOT EDIT
import { z, testRegex } from '@talbenmoshe/atlas-api/client';
export { toSnakeCase } from './caseTransform.js';
// ============ Component Validation Schemas ============
export const ServiceStatusResponseSchema = z.object({
    service: z.string(),
    databaseValue: z.string(),
}).loose();
export const SignedInAccountResponseSchema = z.object({
    accountId: z.string(),
    email: z.string(),
}).loose();
export const NotSignedInErrorSchema = z.object({
    reason: z.literal('not-signed-in'),
}).loose();
export const TripResourceSchema = z.object({
    id: z.uuid(),
    title: z.string(),
    about: z.string(),
    version: z.number().int().min(1),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
}).loose();
export const TripListResponseSchema = z.object({
    trips: z.array(TripResourceSchema),
}).loose();
export const CreateTripBodySchema = z.object({
    title: z.string(),
}).loose();
export const InvalidTripRequestErrorSchema = z.object({
    reason: z.enum(['invalid-title', 'invalid-about', 'idempotency-key-reused']),
}).loose();
export const TripNotFoundErrorSchema = z.object({
    reason: z.literal('trip-not-found'),
}).loose();
export const TripFieldPathSchema = z.enum(['title', 'about']);
export const UpdateTripBodySchema = z.object({
    trip: TripResourceSchema,
    updateMask: z.array(TripFieldPathSchema).min(1).refine((items) => new Set(items).size === items.length, { message: 'Array items must be unique' }),
}).loose();
export const TripVersionConflictErrorSchema = z.object({
    reason: z.literal('stale-version'),
    trip: TripResourceSchema,
}).loose();
// ============ Request Schemas ============
export const GetTripOsServerStatusRequestSchema = z.object({}).loose();
export const GetSignedInAccountRequestSchema = z.object({}).loose();
export const ListTripsRequestSchema = z.object({}).loose();
export const CreateTripRequestSchema = z.object({
    idempotencyKey: z.string().min(1).max(255),
    title: z.string(),
}).loose();
export const GetTripRequestSchema = z.object({
    tripId: z.string().min(1).max(64),
}).loose();
export const UpdateTripRequestSchema = z.object({
    tripId: z.string().min(1).max(64),
    idempotencyKey: z.string().min(1).max(255),
    trip: TripResourceSchema,
    updateMask: z.array(TripFieldPathSchema).min(1).refine((items) => new Set(items).size === items.length, { message: 'Array items must be unique' }),
}).loose();
export const DeleteTripRequestSchema = z.object({
    tripId: z.string().min(1).max(64),
    version: z.coerce.number().int().min(1),
    idempotencyKey: z.string().min(1).max(255),
}).loose();
// ============ Response Schemas ============
export const ServiceStatusResponseResponseSchema = ServiceStatusResponseSchema;
export const SignedInAccountResponseResponseSchema = SignedInAccountResponseSchema;
export const TripListResponseResponseSchema = TripListResponseSchema;
export const TripResourceResponseSchema = TripResourceSchema;
// ============ Inferred Type Exports ============
// These types represent the transformed output (camelCase) from Zod schemas.
// Use these types for consumer-facing APIs instead of wire-format types.
//# sourceMappingURL=TripOsServerAPISchemas.js.map